import React, { Component } from 'react';
import SecureLayout from '../../../templates/secure';
import {NavLink} from 'react-router-dom';
import _ from 'lodash';

class AgenciesAdd extends Component{
	render(){
		const {agencies} =this.props;
		let ac = _.find(agencies.permissions, (o) => {return o==='Create'});
		return (
			ac ?
				<p>
					<NavLink to={`/instancias/crear`} className="button is-small is-inm-purple">{'Agregar Instancia'}</NavLink>
				</p>:''
		)
	}
}

export default SecureLayout(AgenciesAdd);


// WEBPACK FOOTER //
// ./src/elements/agencies/widget/agencies_add.jsx